module.exports = __webpack_public_path__ + "notion-logo.png?4fe25175e6dc6fb0122fafa57513cfa8";